import { Auth } from 'aws-amplify';

export default async function currentUserToken() {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
}
